import React from 'react';

import { Helmet } from 'react-helmet';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Container, Paper, Stack, Typography } from '@mui/material';

function TripPlannerPage() {
  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>TripPlanner</title>
      </Helmet>
      <Box
        sx={{
          display: 'grid',
          gap: 3,
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(2, minmax(0, 1fr))',
          },
        }}
      >
        <Paper sx={{ p: 4, minHeight: 260, display: 'flex' }}>
          <Stack spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h4" gutterBottom>
                Classic
              </Typography>
              <Typography color="text.secondary">
                Access the existing trip planner admin workflows, including trip lookup, preferences, locations, cart
                generation, and suggested place images.
              </Typography>
            </Box>

            <Button component={RouterLink} to="/trip-planner/classic/trips" variant="outlined" size="large">
              Open Classic
            </Button>
          </Stack>
        </Paper>

        <Paper sx={{ p: 4, minHeight: 260, display: 'flex' }}>
          <Stack spacing={2} justifyContent="space-between">
            <Box>
              <Typography variant="h4" gutterBottom>
                Chat
              </Typography>
              <Typography color="text.secondary">
                Enter the new chat-based trip planner section. This is the primary path for future admin pages.
              </Typography>
            </Box>

            <Button component={RouterLink} to="/trip-planner/chats" variant="contained" size="large">
              Open Chat
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Container>
  );
}

export default TripPlannerPage;
